import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import WhyChooseGrawish from "../components/WhyChooseGrawish";
import GrawishImpact from "../components/GrawishImpact";
import AIEcosystem from "../components/AIEcosystem";
import ProvenResults from "../components/ProvenResults";
import ClientsSection from "../components/ClientsSection";
import TestimonialsSection from "../components/TestimonialsSection";
import GrawishCore from "../components/GrawishCore";
import Services from "../components/Services";
import EventManagement from "../components/EventManagement";
import GiftingMerchandise from "../components/GiftingMerchandise";
import HowItWorks from "../components/HowItWorks";
import StartGrowing from "../components/StartGrowing";
import WhyGrawish from "../components/WhyGrawish";
import Comparison from "../components/Comparison";
import Footer from "../components/Footer";
import ContactModal from "../components/ContactModal";
import InquiryModal from "../components/InquiryModal";
import ContactSection from "../components/ContactSection";

const HomePage = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const openContact = () => setIsContactOpen(true);
  const [isInquiryOpen, setIsInquiryOpen] = useState(false);
  const openInquiry = () => setIsInquiryOpen(true);

  return (
    <div className="min-h-screen bg-white" data-testid="homepage">
      <Navbar onContactClick={openContact} />
      <Hero onContactClick={openContact} />
      <WhyChooseGrawish />
      <GrawishImpact onQuickOpen={openInquiry} />
      <AIEcosystem />
      <ProvenResults onQuickOpen={openInquiry} />
      <ClientsSection />
      <TestimonialsSection />
      <GrawishCore />
      <Services onQuickOpen={openInquiry} />
      <EventManagement onContactClick={openContact} />
      <GiftingMerchandise onContactClick={openContact} />
      <HowItWorks onQuickOpen={openInquiry} />
      <StartGrowing onContactClick={openContact} />
      <WhyGrawish />
      <Comparison />
      <ContactSection className="py-24 section-white" />
      <Footer onContactClick={openContact} />
      <ContactModal
        isOpen={isContactOpen}
        onClose={() => setIsContactOpen(false)}
      />
      <InquiryModal isOpen={isInquiryOpen} onClose={() => setIsInquiryOpen(false)} />
    </div>
  );
};

export default HomePage;
